import EnvSettings from "../../Utils/EnvSettings";
import { getToken } from "../../Utils/Common";

export async function taskRequest(endpoint, body = {}) {
  const response = await fetch(`${EnvSettings.server}/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...body, token: getToken() }),
  });
  const result = await response.json();
  if (!response.ok || result.error) throw new Error(result.message || "Unable to load or save tasks.");
  return result;
}
